import { render, staticRenderFns } from "./AvaliacoesPorOperador.vue?vue&type=template&id=4a329946&scoped=true&"
import script from "./AvaliacoesPorOperador.vue?vue&type=script&lang=js&"
export * from "./AvaliacoesPorOperador.vue?vue&type=script&lang=js&"
import style0 from "./AvaliacoesPorOperador.vue?vue&type=style&index=0&id=4a329946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a329946",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VTextField})
